import { DevicesAPI, IRegisterRoomParams } from "../../services/hcnApi";

export const registerRoomUseCase = async (params: IRegisterRoomParams) => {
  await DevicesAPI.registerRoom(params);
};
